import { Container } from '@chakra-ui/react';
import { NextPage } from 'next';
import { getSession } from 'next-auth/react';

import { withSession } from '@/lib/session';
import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import Article from '@/components/Article';
import ArticleContent from '@/components/Article/articleContent';
import { H1 } from '@/components/Heading';
import Seo from '@/components/Seo';

import { LocaleProps } from '@/models/props/LocalizationProps';
import { ClubRegulationsService } from '@/services/ClubRegulationsService';

type ClubRegulationsProps = {
    content: Record<string, string>;
};

const ClubRegulationsPage: NextPage<ClubRegulationsProps> = (props: ClubRegulationsProps) => {
    const content = props.content;

    return (
        <>
            <Seo templateTitle={content.title} />
            <Container maxW="container.2xl">
                <Article>
                    <H1 textAlign="center">{content.title}</H1>
                    <ArticleContent content={content.content} />
                </Article>
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    withSession(async (context) => {
        const session = await getSession(context);
        const { locale } = context;
        let content;

        try {
            if (session && session.user?.hasCredentials) {
                content = await ClubRegulationsService.getClubRegulations(locale as LocaleProps);
            } else {
                content = await ClubRegulationsService.getGuestRegulations(locale as LocaleProps);
            }
        } catch {
            content = [];
        }

        if (content.length === 0) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                content
            }
        };
    })
);

export default ClubRegulationsPage;
